import React, { useState } from 'react'
import {
  Container,
  Image,
  Tabs,
  TextTitle,
  ToastContext,
  Link,
  ListContainer,
  TextBody,
  Button,
  Icon
} from '@pmi/pmi-iqos-ds-react'
import {
  mapProductInfoForDisplay,
  parseTranslations,
  analytics,
  setTranslations,
  CommonTranslations,
  PublishedComponent,
  cookie,
  JWTDecode,
  updateCartCounter,
  htmlTranslation,
  getToastMessagesFromResponse,
  goTo,
  Routes,
  extractErrorCode,
  fillProductsWithExtraData,
  isPurchaseLimitationsErrorCode,
  isCartPurchaseLimitationsErrorCode,
  getToastMessagesFromError,
  isAuthenticated,
  checkStockNotification,
  constants,
  resetGrecaptcha,
  getInitialPropsMock
} from '@pmi/pmi-iqos-shared-react'
import { api } from '@dcx-common/services'
import { ModalNotifyMe, ProductCardProduct } from '@dcx-common/components'
import ProductLineUpTranslations from './product-line-up.json'

const ProductLineUpComponent = ({
  translations,
  productsData,
  title,
  description,
  isShortDescription,
  category,
  categoryId,
  textLink,
  disclaimer
}) => {
  const [productDataItems, setProductDataItems] = useState(productsData)
  const [selectedItem, setSelectedItem] = useState(
    productsData && productsData[0].id
  )
  const [loadingExtraData, setLoadingExtraData] = useState(true)
  const [modalNotifyMe, setModalNotifyMe] = useState({
    key: 0,
    isOpen: false,
    product: null,
    selectedOptionIndex: 0,
    isAuthenticated: false,
    email: undefined,
    name: undefined
  })

  const toastContext = ToastContext.getContextActions()

  const { popupToast, dismissToast } = toastContext

  React.useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    await getProductsExtraData()
  }

  const handleItemSelected = item => {
    setSelectedItem(item.id)
    analytics.productDetailSelection(item.name)
  }

  const getProductsExtraData = async () => {
    setLoadingExtraData(true)
    const promises = []
    let products = []

    if (categoryId) {
      const params = {
        categoryid: categoryId,
        stock: true,
        promo: true
      }
      const res = await api.cart.getProducts({ params })
      products = res.products
    } else {
      productsData &&
        productsData.forEach(item => {
          const params = {
            productid: item.id,
            stock: true,
            promo: true
          }
          promises.push(api.cart.getProducts({ params }))
        })
      await Promise.all(promises).then(results => {
        results.forEach(async res => {
          products = [...products, ...res.products]
        })
      })
    }
    const productsList = fillProductsWithExtraData(productDataItems, products)
    setProductDataItems(productsList)
    setLoadingExtraData(false)
  }

  const handleGoToCart = familyWarining => {
    familyWarining && analytics.productFamilyConflictDecision(true)
    goTo(Routes.cart, true)
  }

  const handleKeepShopping = familyWarining => {
    familyWarining && analytics.productFamilyConflictDecision(false)
    dismissToast()
  }

  const cartFreeShippingToastContent = msg => {
    return (
      <Container display={Container.displays.flex} pb="2">
        <Container pr="2">
          <Icon size={Icon.sizes.s} image={Icon.images.orders} />
        </Container>
        <TextBody size={TextBody.sizes.s} acceptsHtml value={msg} />
      </Container>
    )
  }
  const handleOnComparisonClick = () => {
    analytics.onProductLineUpClick({
      eventCategory: category,
      eventLabel: 'Generation Comparison'
    })
  }

  const handleAddToCart = async (product, selectedOptionIndex) => {
    const token = cookie.getToken()
    const decodedToken = JWTDecode(token)
    if (
      decodedToken &&
      decodedToken.has_device_registered === 'false' &&
      product.isRequiredDeviceRegistration
    ) {
      popupToast({
        type: ToastContext.types.error,
        subtitle: translations.tk_productNeedsRegisteredDevices
      })
      return false
    }
    try {
      const selectedOption = product.options[selectedOptionIndex]
      const res = await api.cart.addToCart([
        { id: product.id, qty: 1, option: selectedOption }
      ])
      updateCartCounter(res.amount)
      const showFamilyWarning = res.familyNotice && !cookie.getFamilyWarning()
      if (showFamilyWarning) {
        cookie.setFamilyWarning(true)
        analytics.productFamilyConflict(false)
      }
      popupToast({
        disclaimer: res.promotionDisclaimer,
        type: res.error ? ToastContext.types.error : ToastContext.types.none,
        title: res.error
          ? translations.tk_addedToCartError
          : translations.tk_addedToCart,
        subtitle: product.options[selectedOptionIndex].variantName,
        content: (
          <Container>
            {res.free_shipping_message &&
              cartFreeShippingToastContent(res.free_shipping_message)}
            {showFamilyWarning && (
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(translations, 'tk_addedToCartFamilyNotice')}
              />
            )}
            <TextBody size={TextBody.sizes.s}>
              {getToastMessagesFromResponse(res)}
            </TextBody>
          </Container>
        ),
        actions: [
          <Button
            key={0}
            fullWidth
            variant={Button.variants.secondary}
            text={translations.tk_toastKeepShopping}
            onClickHandler={() => handleKeepShopping(showFamilyWarning)}
          />,
          <Button
            key={1}
            fullWidth
            variant={Button.variants.primary}
            text={translations.tk_toastProceedToCart}
            onClickHandler={() => handleGoToCart(showFamilyWarning)}
          />
        ]
      })
    } catch (err) {
      const errorCode = extractErrorCode(err)
      const isPLError = isPurchaseLimitationsErrorCode(errorCode)
      if (isPLError) {
        analytics.addToCartLimitations(
          product &&
            product.options &&
            product.options[selectedOptionIndex].variantId,
          product &&
            product.options &&
            product.options[selectedOptionIndex].variantName,
          isCartPurchaseLimitationsErrorCode(errorCode)
        )
      }
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_addedToCartError,
        subtitle:
          product &&
          product.options &&
          product.options[selectedOptionIndex].variantName,
        content: (
          <Container>
            <TextBody
              size={TextBody.sizes.s}
              acceptsHtml
              value={getToastMessagesFromError(err)}
            />
            {isPLError && (
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(
                  translations,
                  'tk_purchaseLimitationsErrorTermsAndConditions'
                )}
              />
            )}
          </Container>
        )
      })
    }
  }

  const handleAddToPreorder = async (product, selectedOptionIndex) => {
    if (isAuthenticated()) {
      try {
        const profile = await api.profile.getProfile()
        const stockNotification = await api.cart.getStockNotification(product)
        const alreadySubscribed = checkStockNotification(
          product,
          selectedOptionIndex,
          stockNotification
        )
        if (alreadySubscribed) {
          popupToast({
            type: ToastContext.types.none,
            subtitle: translations.tk_notifyMeAlreadySubscribedTitle
          })
        } else {
          setModalNotifyMe({
            key: Math.random(),
            product: product,
            selectedOptionIndex: selectedOptionIndex,
            isAuthenticated: true,
            email: profile.EmailAddress,
            name: profile.LastName + ' ' + profile.FirstName,
            isOpen: true
          })
        }
      } catch (err) {
        popupToast({
          type: ToastContext.types.error,
          subtitle: translations.tk_addedToPreorderError
        })
      }
    } else {
      setModalNotifyMe({
        key: Math.random(),
        product: product,
        selectedOptionIndex: selectedOptionIndex,
        isAuthenticated: false,
        email: undefined,
        name: undefined,
        isOpen: true
      })
    }
  }

  const handleOnNotifyMe = async (
    userInfo,
    product,
    selectedOptionIndex,
    recaptchaData
  ) => {
    const selectedOption = product.options[selectedOptionIndex]
    try {
      await api.cart.addStockNotification(
        userInfo,
        product.id,
        selectedOption,
        recaptchaData
      )
      return {
        success: true
      }
    } catch (err) {
      const code =
        err.data &&
        Array.isArray(err.data) &&
        err.data.length > 0 &&
        err.data[0].code
      if (
        code === constants.CAPTCHA_VALIDATION_ERROR_01 ||
        code === constants.CAPTCHA_VALIDATION_ERROR_02
      ) {
        return {
          success: false,
          captchaError: true
        }
      } else {
        resetGrecaptcha(constants.STOCK_NOTIFICATION_GRECAPTCHA_ACTION)
        popupToast({
          type: ToastContext.types.error,
          subtitle: translations.tk_addedToPreorderError
        })
        return {
          success: false,
          captchaError: false,
          error:
            err.data &&
            Array.isArray(err.data) &&
            err.data.length > 0 &&
            err.data[0].message
        }
      }
    }
  }
  if (translations) {
    setTranslations(translations)
  }

  if (productDataItems && productDataItems.length > 0) {
    return (
      <Container>
        <Container
          pt={['16', '24', '32']}
          pb={['8', '12', '16']}
          px={['8', '8', '16']}
          bg={Container.backgrounds.white}>
          <TextTitle
            heading={TextTitle.headings.h3}
            alignment={TextTitle.alignments.center}>
            {title}
          </TextTitle>
          {description && (
            <Container
              justifyContent={ListContainer.justifyContentValues.center}
              display={[Container.displays.flex]}>
              <Container pt="4" width={['full', 'full', '1/2']}>
                <TextBody
                  alignment={TextTitle.alignments.center}
                  style={TextBody.styles.strong}
                  size={TextBody.sizes.s}
                  acceptsHtml
                  value={description}
                />
              </Container>
            </Container>
          )}
        </Container>

        <Container
          display={[Container.displays.block, Container.displays.none]}
          bg={Container.backgrounds.white}>
          <Container
            divider={Container.dividers.bottom}
            layout={Container.layouts.small}>
            {!categoryId && (
              <Tabs
                items={productDataItems}
                nowrap={false}
                onItemSelectedHandler={handleItemSelected}
                getItemLabel={item => item?.name}
                isItemSelected={item => item.id === selectedItem}
                getAdditionalTemplate={item => (
                  <Image
                    src={
                      item.options &&
                      item.options[0] &&
                      item.options[0].images &&
                      item.options[0].images[0].path
                    }
                    alt={
                      item.options &&
                      item.options[0] &&
                      item.options[0].images &&
                      item.options[0].images[0].alt
                    }
                    height="20"
                  />
                )}
                isItemDisabled={item => item.disabled}
              />
            )}
          </Container>
        </Container>
        <Container pb="8" px={['8', '8', '16']}>
          <Container
            display={[Container.displays.block, Container.displays.none]}>
            {productDataItems.map((product, index) => {
              if (product.id === parseInt(selectedItem) || categoryId) {
                return (
                  <Container pt="8" key={index}>
                    <ProductCardProduct
                      onAddToCart={handleAddToCart}
                      onAddToPreorder={handleAddToPreorder}
                      translations={translations}
                      productPosition={index}
                      product={product}
                      isPXP
                      mainCategoryName={category}
                      loading={loadingExtraData}
                      isShortDescription={isShortDescription}
                    />
                  </Container>
                )
              }
            })}
          </Container>
          <Container
            display={[Container.displays.none, Container.displays.block]}>
            <ListContainer
              columns={[1, 2, 3]}
              xBetween="8"
              yBetween="20"
              justifyContent={ListContainer.justifyContentValues.center}
              fullWidth>
              {productDataItems.map(
                (product, index) =>
                  product.options && (
                    <Container
                      key={index}
                      display={Container.displays.flex}
                      fullWidth>
                      <ProductCardProduct
                        onAddToCart={handleAddToCart}
                        onAddToPreorder={handleAddToPreorder}
                        translations={translations}
                        productPosition={index}
                        product={product}
                        isPXP
                        mainCategoryName={category}
                        loading={loadingExtraData}
                        isShortDescription={isShortDescription}
                      />
                    </Container>
                  )
              )}
            </ListContainer>
          </Container>

          <Container pt="10">
            <TextBody alignment={TextBody.alignments.center}>
              <Link
                href={textLink && textLink.url}
                onClickHandler={handleOnComparisonClick}
                newTab={textLink && textLink.open_new_tab}>
                {textLink && textLink.text}
              </Link>
            </TextBody>
          </Container>

          <Container pt="10">
            <TextBody
              alignment={TextBody.alignments.center}
              acceptsHtml
              size={TextBody.sizes.xs}
              value={disclaimer}
            />
          </Container>
        </Container>
        <ModalNotifyMe
          key={modalNotifyMe.key}
          isAuthenticated={modalNotifyMe.isAuthenticated}
          defaultEmail={modalNotifyMe.email}
          defaultName={modalNotifyMe.name}
          translations={translations}
          isOpen={modalNotifyMe.isOpen}
          product={modalNotifyMe.product}
          selectedOptionIndex={modalNotifyMe.selectedOptionIndex}
          handleOnNotifyMe={handleOnNotifyMe}
          onClose={() => {
            setModalNotifyMe({
              ...modalNotifyMe,
              ...{ isOpen: false }
            })
          }}
        />
      </Container>
    )
  }
  return null
}

const ProductLineUp = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={ProductLineUpComponent}
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...ProductLineUpTranslations,
  ...CommonTranslations
}

const ComponentDefaultProps = {
  componentName: 'ProductLineUp',
  translations: {
    ...parseTranslations(ComponentTranslations, true)
  }
}

ProductLineUp.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: async () => {
      const productLineUp =
        req?.query?.mock === 'true'
          ? getInitialPropsMock('productLineUp')
          : req.body.extra.product_line_up
      const variantIdHide =
        (req.body.extra && req.body.extra.variantidhide) || []
      const categoryId = req.query && req.query.category // 2143
      const tabItems = productLineUp && productLineUp.products
      let products = []

      if (categoryId) {
        const res = await api.cart.getProducts({
          req,
          params: {
            categoryid: categoryId
          }
        })
        res.products.forEach(res => {
          const { product } = mapProductInfoForDisplay(res)
          products = [...products, product]
        })
      } else {
        const promises = []
        tabItems &&
          tabItems.length > 0 &&
          tabItems.forEach(item => {
            const params = {
              productid: item,
              variantid: 0
            }
            promises.push(api.cart.getProducts({ req, params }))
          })
        await Promise.all(promises).then(results => {
          results.forEach(res => {
            const { product } = mapProductInfoForDisplay(
              res.products && res.products[0],
              tabItems
            )
            products = [...products, product]
          })
        })
      }

      const filteredProducts = products.reduce((list, product) => {
        const filteredOptions = product.options.filter(
          option =>
            !variantIdHide
              .map(v => parseInt(v))
              .includes(parseInt(option.variantId))
        )
        return filteredOptions.length > 0
          ? [...list, { ...product, options: filteredOptions }]
          : list
      }, [])

      return {
        categoryId,
        productsData: filteredProducts,
        title: productLineUp && productLineUp.title,
        description: productLineUp && productLineUp.description,
        isShortDescription: productLineUp && productLineUp.short_description,
        disclaimer: productLineUp && productLineUp.disclaimer,
        textLink: productLineUp && productLineUp.text_link,
        category: productLineUp && productLineUp.category
      }
    }
  })
}

export default ProductLineUp
